const ɵ0 = {
    hideRequiredMarker: true,
};
export class MaterialModule {
}
export { ɵ0 };
